import { render } from "./AdminAudienceMetrics.vue?vue&type=template&id=0405da0e&scoped=true"
import script from "./AdminAudienceMetrics.vue?vue&type=script&lang=js"
export * from "./AdminAudienceMetrics.vue?vue&type=script&lang=js"

import "./AdminAudienceMetrics.vue?vue&type=style&index=0&id=0405da0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0405da0e"]])

export default __exports__